import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { SignDocumentRequestService } from "@routes/sign-request/services/sign-document-request.service";

export interface SrStep {
    path: string;
    label: string;
    hide?: boolean;
}

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSwitchComponent } from '../../language-switch/language-switch.component';
import { HelpContentComponent } from '../../help-content/help-content.component';

@Component({
    selector: 'app-sr-steps-header',
    templateUrl: './sr-steps-header.component.html',
    styles: [],
    standalone: true,
    imports: [CommonModule, RouterModule, TranslateModule, LanguageSwitchComponent, HelpContentComponent]
})
export class SrStepsHeaderComponent implements OnInit, OnDestroy {
    protected readonly router = inject(Router);
    protected readonly activatedRoute = inject(ActivatedRoute);
    protected readonly signDocumentRequest = inject(SignDocumentRequestService);
    @Input() steps!: SrStep[];
    @Input() key!: string;
    private _activeUrl!: string;
    public activeIndex = 0;
    private subscription: Subscription = new Subscription();

    ngOnInit() {
        if (this.activatedRoute.snapshot.firstChild) {
            this._activeUrl = this.activatedRoute.snapshot.firstChild?.url[0].path;
            this.updateActiveIndex();
        }

        this.subscription.add(this.router.events.pipe(
            filter(e => e instanceof NavigationEnd)
        ).subscribe((e: any) => {
            const urlpart = e.urlAfterRedirects.split('/').pop();
            if (urlpart) {
                this._activeUrl = urlpart;
                this.updateActiveIndex();
            }
        }));
    }

    private updateActiveIndex() {
        if (this.steps) {
            this.activeIndex = this.steps.findIndex(step => step.path === this._activeUrl);
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
